<template>
  <div>
    <slot :width="width" />
    <GlobalEvents target="window" @resize="refresh" />
  </div>
</template>

<script>
import GlobalEvents from 'vue-global-events';

export default {
  components: {
    GlobalEvents
  },
  data: () => ({
    width: null
  }),
  destroyed() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  mounted() {
    this.refresh();
    if (typeof window !== 'undefined' && window.ResizeObserver) {
      this.width = this.$el.getBoundingClientRect().width;
      this.observer = new ResizeObserver(([entry]) => {
        this.width = entry.contentRect.width;
      });
      this.observer.observe(this.$el);
    }
  },
  methods: {
    refresh() {
      this.width = this.$el.getBoundingClientRect().width;
    }
  }
};
</script>
